module.exports = __webpack_public_path__ + "media/assets/images/flags/vi-067e724b26eb2a577fb2ea2b5c7a01e6.svg";